import { config } from "shared/data";

export const AB_WIDGET_API_TIMEOUT_MS = 10_000;

export const AB_WIDGET_FETCH_API_ENDPOINT = `${config.abWidgetApi.host}/recommend/v2`;

export const AB_WIDGET_FETCH_LOG_PREFIX = "[AB Widget Fetch]";

export enum AbWidgetFetchVariant {
  Control = "control",
  V1 = "v1",
  V2 = "v2",
}
